<template>
  <div class="GridItem"
    :class="classes"
    :style="styles">

    <slot />

  </div>
</template>

<script>
export default {
  name: 'GridItem',

  props: {
    span: {
      type: String
    },

    /**
     * Order
     * - Useful for changing order of grid items, as in the 'multi'
     *   type in the MediaGrid component.
     * - Probably shouldn't be used in other cases for now.
     * @type {Object}
     */
    order: {
      type: Number
    }
  },

  computed: {
    /**
     * Clases for the main element
     * @return {Array}
     */
    classes () {
      const classes = []
      if (this.span) classes.push(`GridItem--${this.span}`)
      return classes
    },

    /**
     * Styles for the main element
     * @return {Object}
     */
    styles () {
      const styles = {}
      if (this.order) styles['order'] = this.order
      return styles
    }
  }
}
</script>

<style>
@import 'properties';

.GridItem {
  float: left;

  @supports (display: grid) {
    float: none;
  }

  @media (max-width: 599px) {
    order: unset !important;
  }
}

/* Full span by default */
.GridItem,
.GridItem--12\/12,
.GridItem--6\/6,
.GridItem--4\/4,
.GridItem--3\/3,
.GridItem--2\/2,
.GridItem--1\/1 {
  width: 100%;

  @supports (display: grid) {
    width: auto;
    grid-column: span 12;
  }
}

.GridItem--11\/12 {

  @media (min-width: 800px) {
    width: 91.6666667%;

    @supports (display: grid) {
      width: auto;
      grid-column: span 11;
    }
  }
}

.GridItem--10\/12
.GridItem--5\/6 {

  @media (min-width: 800px) {
    grid-column: span 10;
  }
}

.GridItem--9\/12,
.GridItem--3\/4 {

  @media (min-width: 800px) {
    grid-column: span 9;
  }
}

.GridItem--8\/12,
.GridItem--4\/6,
.GridItem--2\/3 {

  @media (min-width: 800px) {
    grid-column: span 8;
  }
}

.GridItem--7\/12 {

  @media (min-width: 800px) {
    grid-column: span 7;
  }
}

.GridItem--6\/12,
.GridItem--3\/6,
.GridItem--2\/4,
.GridItem--1\/2 {

  @media (min-width: 800px) {
    grid-column: span 6;
  }
}

.GridItem--5\/12 {

  @media (min-width: 800px) {
    grid-column: span 5;
  }
}

.GridItem--4\/12,
.GridItem--2\/6,
.GridItem--1\/3 {

  @media (min-width: 800px) {
    grid-column: span 4;
  }
}

.GridItem--3\/12,
.GridItem--1\/4 {

  @media (min-width: 400px) {
    width: 25%;

    @supports (display: grid) {
      width: auto;
      grid-column: span 6;
    }
  }

  @media (min-width: 800px) {
    grid-column: span 3;
  }
}

.GridItem--2\/12,
.GridItem--1\/6 {

  @media (min-width: 800px) {
    grid-column: span 2;
  }
}

.GridItem--1\/12 {

  @media (min-width: 800px) {
    grid-column: span 1;
  }
}
</style>



// WEBPACK FOOTER //
// GridItem.vue?583755fa